import React from 'react'

import ImageHeader from '../components/header.js'
import ServicesIcons from '../components/services.js'
import About from '../components/about.js'
import Map from '../components/map.js'

const IndexPage = () => (
	<section>
		<ImageHeader />
		<ServicesIcons />
		<About />
		<Map isMarkerShown />
	</section>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js